import zendeskService from "./zendeskService";
import store from "../../store/store";

class ScriptService {
    constructor() {
        this.scripts = [];
    }

    /**
     * Create new script with attributes 
     * @param {{ src: string, async: boolean, id: string, callback: Function }} attributes 
     * @returns 
     */
    _createScript(attributes = {}) {
        const script = document.createElement("script");
    
        for(let key in attributes || {}) {
            if(key !== "callback") {
                script.setAttribute(key, attributes[key] || "");
            }
        }
    
        return {
            $el: script,
            attributes,
        };
    }

    /**
     * The main function to handle append & load script to body document
     * @returns
     */
    _onLoadScriptInBody() {
        // Loop and append script to document body
        this.scripts.map((script) => {
            const cb = script.attributes.callback;

            if($(`#${script.attributes.id}`).length === 0) {
                $(document.body).append(script.$el);
            }
            else {
                this.scripts = this.scripts.filter((_script) => _script.attributes.id !== script.attributes.id)
            }

            // Execution function 
            if(cb && typeof cb === "function") {
                cb();
            }
        });

        // Remove events when script have length equal 0
        if(this.scripts.length === 0) {
            $(document.body).off("click touchstart scroll keypress mousemove", this._onLoadScriptInBody.bind(this));
        }
    }

    load() {
        // You can add new script at here
        // Warn: The scripts at here should load when user do some action below

        this.scripts = [
            // zendesk
            this._createScript({
                src: "https://static.zdassets.com/ekr/snippet.js?key=1ca9d846-850e-44e9-83f5-0e36c00a1cf7",
                async: true,
                id: "ze-snippet",
                callback: () => {
                    zendeskService.authenticate();
                }
            }),
            // Firebase
            this._createScript({
                src: "https://www.gstatic.com/firebasejs/7.9.3/firebase-app.js",
                async: true,
                id: "firebase-app",
                callback: null
            })
        ];

        $(document.body).on("click touchstart scroll keypress mousemove", this._onLoadScriptInBody.bind(this));
    }
}

const scriptService = new ScriptService();

export default scriptService;


// WEBPACK FOOTER //
// ./src/core/services/scriptService.js